import { render, staticRenderFns } from "./UiElementEdit.vue?vue&type=template&id=15c1a6f4"
import script from "./UiElementEdit.vue?vue&type=script&lang=js"
export * from "./UiElementEdit.vue?vue&type=script&lang=js"
import style0 from "./UiElementEdit.vue?vue&type=style&index=0&id=15c1a6f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports